import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as React from "react";
import ErrorPage from "components/errors/ErrorPage";
import usePluginEntities from "hooks/usePluginEntities";
import useProductName from "brand-customization/useProductName";
import processHooks from "./processHooks";
const LoadViewError = ({ error }) => {
  const { t } = useTranslation("search");
  const productName = useProductName();
  useEffect(() => {
    console.log(error);
  }, [error]);
  return /* @__PURE__ */ React.createElement(
    ErrorPage,
    {
      title: t("view_errors.something_went_wrong"),
      description: /* @__PURE__ */ React.createElement("p", null, t("view_errors.unknown_error", { productName }))
    },
    /* @__PURE__ */ React.createElement("pre", null, error == null ? void 0 : error.message)
  );
};
const useProcessHooksForView = (view, executionState, query) => {
  const loadingViewHooks = usePluginEntities("views.hooks.loadingView");
  const executingViewHooks = usePluginEntities("views.hooks.executingView");
  const [result, setResult] = useState({ status: "loading" });
  useEffect(
    () => {
      processHooks(view, executionState, loadingViewHooks, executingViewHooks, query, (v, e) => {
        setResult({ status: "loaded", view: v, executionState: e });
      }).catch((e) => {
        if (e instanceof Error) {
          console.error(e);
        }
        const component = e instanceof Error ? /* @__PURE__ */ React.createElement(LoadViewError, { error: e }) : e;
        setResult({ status: "interrupted", component });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [executingViewHooks, loadingViewHooks, view]
  );
  return result;
};
export default useProcessHooksForView;
